module.exports = __webpack_public_path__ + "static/gatsby-icon-alt-2f1cb490f01b0ea6d651488dc4e241c7.png";